import balinghe from "./index.vue";
import balingheHome from "./Home.vue";

const emptyComponent = () => import("./emptyRouterComponent.vue");
const gasClampUp = () => import("./gasClamp_up.vue");
const gasClampDown = () => import("./gasClamp_down.vue");
const gasClampSaddleAnchor = () => import("./gasClamp_saddleAnchor.vue");
const cableClamp = () => import("./cableClamp.vue");
const station = () => import("./station.vue");
const simpleCurrentData = () => import("./../../components/SimpleCurrentData.vue");
const highFrequencyDataTable = () => import("./../../components/HighFrequencyCurrentData.vue");
const dataHistory = () => import("./../../components/DataHistory.vue");
const highFrequencyDeviceControl = () => import("./../../components/HighFrequencyStatusControl.vue");
const SimpleHumidityList = () => import("../../components/SimpleHumidityList.vue");
const login = () => import("./login.vue");
const errorRecord = () => import("./../../components/ErrorRecordControl.vue");
const stationAnchorSaddle = () => import("./station_anchorSaddle.vue");

export default [
  {
    path: "/balingheSensorIndex",
    name: "balingheSensorIndex",
    component: balingheHome,
  },
  {
    path: "/balingheSensor/login",
    name: "balingheSensorLogin",
    component: login,
  },

  {
    path: "/balingheSensor",
    name: "balingheSensor",
    redirect: "/balingheSensor",
    component: balinghe,
    children: [
      {
        path: "currentDataTable",
        name: "currentDataTable",
        component: simpleCurrentData,
      },
      {
        path: "errorRecord",
        name: "errorRecord",
        component: errorRecord,
      },
      {
        path: "currentHumidityList",
        name: "currentHumidityList",
        component: SimpleHumidityList,
      },
      {
        path: "highFrequencyData",
        name: "highFrequencyData",
        component: highFrequencyDataTable,
      },
      {
        path: "highFrequencyDevice",
        name: "highFrequencyDevice",
        component: highFrequencyDeviceControl,
      },
      {
        path: "gasClamp",
        name: "gasClamp",
        redirect: "/balingheSensor/gasClamp/up",
        component: emptyComponent,
        children: [
          {
            path: "up",
            name: "up",
            component: gasClampUp,
          },
          {
            path: "down",
            name: "down",
            component: gasClampDown,
          },
          {
            path: "saddleAnchor",
            name: "saddleAnchor",
            component: gasClampSaddleAnchor,
          },
        ],
      },
      {
        path: "cableClamp",
        name: "cableClamp",
        component: cableClamp,
      },

      {
        path: "station",
        name: "station",
        redirect: "/balingheSensor/station/left",
        component: emptyComponent,
        children: [
          {
            path: "left",
            name: "left",
            component: station,
          },
          {
            path: "right",
            name: "right",
            component: station,
          },
          {
            path: "middle",
            name: "middle",
            component: station,
          },
        ],
      },

      {
        path: "stationAnchorSaddle",
        name: "stationAnchorSaddle",
        redirect: "/balingheSensor/stationAnchorSaddle/leftAnchor",
        component: emptyComponent,
        children: [
          {
            path: "leftAnchor",
            name: "leftAnchor",
            component: stationAnchorSaddle,
          },
          {
            path: "leftSaddle",
            name: "leftSaddle",
            component: stationAnchorSaddle,
          },
          {
            path: "rightAnchor",
            name: "rightAnchor",
            component: stationAnchorSaddle,
          },
          {
            path: "rightSaddle",
            name: "rightSaddle",
            component: stationAnchorSaddle,
          },
        ],
      },
      {
        path: "dataHistory",
        name: "dataHistory",
        component: dataHistory,
      },
      //   {
      //     path: "errorRecord",
      //     name: "errorRecord",
      //     component: errorRecord,
      //   },
      //   {
      //     path: "cableClamp",
      //     name: "cableClamp",
      //     component: cableClamp
      //   },
      //   {
      //     path: "station",
      //     name: "station",
      //     redirect: "/balingheSensor/station/main1",
      //     component: emptyComponent,
      //     children: [
      //       {
      //         path: "main1",
      //         name: "main1",
      //         component: stationMain
      //       },
      //       {
      //         path: "backup1",
      //         name: "backup1",
      //         component: stationBack
      //       },
      //       {
      //         path: "vent1",
      //         name: "vent1",
      //         component: stationVent
      //       },
      //       {
      //         path: "ventBackup1",
      //         name: "ventBackup1",
      //         component: stationVentBack
      //       },
      //       {
      //         path: "main2",
      //         name: "main2",
      //         component: stationMain
      //       },
      //       {
      //         path: "backup2",
      //         name: "backup2",
      //         component: stationBack
      //       },
      //       {
      //         path: "vent2",
      //         name: "vent2",
      //         component: stationVent
      //       },
      //       {
      //         path: "ventBackup2",
      //         name: "ventBackup2",
      //         component: stationVentBack
      //       },
      //     ],
      //   },

      //   {
      //     path: "steelbox",
      //     name: "steelbox",
      //     redirect: "/balingheSensor/steelbox/southTower",
      //     component: emptyComponent,
      //     children: [
      //       {
      //         path: "southTower",
      //         name: "southTower",
      //         component: stationSteelbox
      //       },
      //     ],
      //   },
      // {
      //   path: "valveClamp",
      //   name: "valveClamp",
      //   redirect: "/balingheSensor/valveClamp/upstream",
      //   component: emptyComponent,
      //   children: [
      //     {
      //       path: "upstream",
      //       name: "upstream",
      //       component: valveClampUpstream
      //     },
      //     {
      //       path: "downstream",
      //       name: "downstream",
      //       component: valveClampDownstream
      //     },
      //   ],
      // },
    ],
  },
];
